/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AttachmentFileApiModel } from './attachmentFileApiModel';
import { OrderContentType } from './orderContentType';
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface PlannedOrderApiModel { 
    employeeId: number;
    employeeTitleBeforeName: string;
    employeeName: string;
    employeeSurname: string;
    employeeTitleAfterName: string;
    employeePersonalNumber: string;
    employerId: number;
    employerName: string;
    orderId: number;
    orderNumber: string;
    orderType: AssessmentTypeEnum;
    orderContentType: OrderContentType;
    providerId?: number | null;
    providerName?: string | null;
    appointmentDate?: string | null;
    attachments: Array<AttachmentFileApiModel>;
}
export namespace PlannedOrderApiModel {
}


